'use client'

import { type MessagesKeys, useTranslate } from '@repo/shared/hooks'
import { MissionCard, MissionCardProps } from './mission-card'
import { Col, SectionSeparator } from '@repo/ui/components'
import { useUserAuthDetails, useGetLoyaltyMissions } from '@repo/services'

export const MissionsContainer = () => {
  const { t } = useTranslate()
  const { data: authDetails } = useUserAuthDetails()
  const phone = authDetails?.data?.phone
  const email = authDetails?.data?.email
  const { data } = useGetLoyaltyMissions()

  const mappedMissions: MissionCardProps[] = (data?.data.missions || []).map(
    (missionItem) => {
      const dependencies = missionItem.mission?.data?.dependency?.missions ?? []

      const unmetDependencies = dependencies.filter((depName) => {
        const depMission = data?.data.missions?.find(
          (m) => m.mission?.name === depName,
        )
        return depMission?.status !== 'completed'
      })

      const hasUnmetDependencies = unmetDependencies.length > 0

      return {
        name: missionItem.mission?.name ?? '',
        title: t(
          `clubPage_mission_item_${missionItem.mission?.name}_title` as MessagesKeys,
        ),
        subTitle: t(
          `clubPage_mission_item_${missionItem.mission?.name}_description` as MessagesKeys,
        ),
        hintPoints:
          missionItem.mission?.name === 'kyc_approval'
            ? [100]
            : missionItem.mission?.name === 'fiat_deposit'
              ? [100, 200, 300, 400]
              : missionItem.mission?.name === 'otc_trade'
                ? [50, 150, 1000]
                : missionItem.mission?.name === 'user_registered'
                  ? [50, 75, 100]
                  : [],
        // name: missionItem.mission?.name,
        receivedPoints: missionItem.milestone?.receivedPoints ?? 0,
        points:
          missionItem.mission?.name === 'user_registered' ||
          missionItem.mission?.name === 'otc_trade'
            ? Infinity
            : missionItem.status === 'completed'
              ? (missionItem.milestone?.receivedPoints ?? 0)
              : (missionItem.mission?.points ?? 0),
        state:
          missionItem.status === 'completed'
            ? 'completed'
            : hasUnmetDependencies
              ? 'disable'
              : 'active',
        actions: [
          {
            type: 'link',
            name: t(
              `clubPage_mission_item_${missionItem.mission?.name}_action_title` as MessagesKeys,
            ),
            url:
              missionItem.mission?.name === 'fiat_deposit'
                ? '/wallet/deposit/online-payment'
                : missionItem.mission?.name === 'kyc_approval'
                  ? phone
                    ? `/auth/quick-kyc?mobileOrEmail=${phone}`
                    : `/auth/kyc?mobileOrEmail=${email}`
                  : missionItem.mission?.name === 'user_registered'
                    ? '/club/invite'
                    : missionItem.mission?.name === 'otc_trade'
                      ? '/quick-trade'
                      : '',
          },
        ],
        unmetDependencies: hasUnmetDependencies
          ? unmetDependencies.map((dep) =>
              t(`clubPage_mission_item_${dep}_title` as MessagesKeys),
            )
          : [],
        progress:
          (missionItem.mission?.data?.milestone?.totalSteps ?? 0) > 1
            ? {
                current: missionItem.milestone?.completedSteps ?? 0,
                total: missionItem.mission?.data?.milestone?.totalSteps ?? 0,
              }
            : undefined,
      }
    },
  )

  return (
    <Col className='gap-lg  mb-20 md:mb-0 -mt-md md:-mt-0 '>
      <Col className='flex  gap-lg'>
        <SectionSeparator />
        {mappedMissions.map((mission, idx) => (
          <MissionCard key={`mission-${idx}`} {...mission} />
        ))}
      </Col>
    </Col>
  )
}
